import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6a85aa16"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "LtlInsuranceTable" }
const _hoisted_2 = { class: "w-full table-auto border-collapse" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", { class: "bg-gray-200" }, [
  /*#__PURE__*/_createElementVNode("th", null, "Номер"),
  /*#__PURE__*/_createElementVNode("th", null, "Дата отправки"),
  /*#__PURE__*/_createElementVNode("th", null, "Объявленная стоимость"),
  /*#__PURE__*/_createElementVNode("th", null, "Файл")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-download" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_button = _resolveComponent("the-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.insurancePolicies, (item, i) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: `service-${i}`
          }, [
            _createElementVNode("td", null, _toDisplayString(item.id), 1),
            _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(item.createdAt)), 1),
            _createElementVNode("td", null, _toDisplayString(_ctx.formatAmount(item.sum)), 1),
            _createElementVNode("td", null, [
              (item.fileUuid)
                ? (_openBlock(), _createBlock(_component_the_button, {
                    key: 0,
                    class: "primary text small",
                    loading: _ctx.state.is_loading,
                    disabled: _ctx.state.is_loading,
                    onClick: ($event: any) => (_ctx.download(item))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_4
                    ]),
                    _: 2
                  }, 1032, ["loading", "disabled", "onClick"]))
                : _createCommentVNode("", true)
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}